import autobind from 'autobind-decorator';
import { Location } from 'history';
import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router';

import { HeaderContext } from 'common/enums/header-context';
import { PageHeader } from 'common/interfaces/page-header';
import { State } from 'common/interfaces/state';
import { CompanySubscriptionModel } from 'unit-account/interfaces/company-subscription-model';
import { AccountSelectors } from 'unit-account/selectors';
import { CompanyManagementPage } from 'unit-people/pages/company-management';
import { RenewSubscriptionPage, SubscribePage, UpdateSubscriptionPage } from 'unit-subscription/pages';
import { SubscriptionStatus } from '../../units/subscription/enums/subscription-status';
import { AppUrls } from '../app-urls';
import { CompanySubscriptionWrap } from '../company-subscription-wrap';
import { SubscriptionParams } from './route-params';
import { Urls } from './urls';


interface StateProps {
  currentLocation: Location;
  subscription: CompanySubscriptionModel;
  isSubscriptionLoaded: boolean;
}

interface Props extends StateProps, RouteComponentProps<SubscriptionParams> {}

class RoutesComponent extends React.Component<Props> {
  private billingHeader: PageHeader = {
    context: HeaderContext.BillingPages,
    backUrl: AppUrls.products.url(),
  };

  public render(): React.ReactNode {
    const subscriptionType = this.props.match.params.type;

    return (
      <CompanySubscriptionWrap subscriptionType={subscriptionType}>
        {this.getContent()}
      </CompanySubscriptionWrap>
    );
  }

  @autobind
  private getContent(): JSX.Element {
    const { subscription, isSubscriptionLoaded } = this.props;
    if (!isSubscriptionLoaded) {
      return null;
    }

    const subscriptionStatus = subscription?.status;
    switch (subscriptionStatus) {
      case SubscriptionStatus.Valid: return this.renderUpdateSubscriptionPage();
      case SubscriptionStatus.Canceled: return this.renderRenewSubscriptionPage();
      case SubscriptionStatus.None:
      default: return this.renderSubscribePage();
    }
  }

  private renderUpdateSubscriptionPage(): JSX.Element {
    return (
      <Switch>
        <Route exact={true} path={Urls.manageCompanySubscription.path} component={CompanyManagementPage} />
        <Route
          path={Urls.updateSubscription.path}
          exact={true}
          metaTitle='Update Subscription'
          component={UpdateSubscriptionPage}
          header={this.billingHeader}
        />
        <Redirect to={Urls.updateSubscription.locationWithCurrentQuery()}/>
      </Switch>
    );
  }

  private renderRenewSubscriptionPage(): JSX.Element {
    return (
      <Switch>
        <Route
          path={Urls.renewSubscription.path}
          exact={true}
          metaTitle='Renew Subscription'
          component={RenewSubscriptionPage}
          header={this.billingHeader}
        />
        <Redirect to={Urls.renewSubscription.locationWithCurrentQuery()}/>
      </Switch>
    );
  }

  private renderSubscribePage(): JSX.Element {
    return (
      <Switch>
        <Route
          path={Urls.subscribe.path}
          exact={true}
          metaTitle='Subscribe'
          component={SubscribePage}
          header={this.billingHeader}
        />
        <Redirect to={Urls.subscribe.locationWithCurrentQuery()}/>
      </Switch>
    );
  }
}

function mapStateToProps(s: State): StateProps {
  return {
    currentLocation: s.router.location,
    subscription: AccountSelectors.currentSubscription(s),
    isSubscriptionLoaded: !!s.account.selectedCompany?.subscriptions,
  };
}

export const Routes = connect(mapStateToProps)(RoutesComponent);
